import { Container, TextArea } from "./styles";

interface IReportModal {
  value: string;
  setValue: (value: string) => void;
}

export const ReportModal = ({ value, setValue }: IReportModal) => {
  return (
    <Container className="modal-body bg-light">
      <h6 className="text-muted text-uppercase small">
        Deseja fazer um breve relato do motivo da consulta?
      </h6>
      <div className="bg-white rounded-4 border p-3 mb-4">
        <TextArea
          value={value}
          onChange={(evt) => setValue(evt.target.value)}
          name="Relato"
          placeholder="Faça o seu relato: Alguma queixa em especial?"
          cols={15}
          rows={5}
        />
      </div>
    </Container>
  );
};
